import widgetHelper from './widgets/widget-utilities/widget-helper';

// Render a particular widget as per the provided config
var renderWidget = function renderWidget(config) {
    // Get widget instance
    var widgetInstance = widgetHelper.getWidgetInstanceForRendering(config);

    // Intitiate rendering for a widget
    widgetInstance.initiateWidgetRendering(config);
};

export default {
    renderWidget: renderWidget
};